import api from "../utils/api";
import {
  USER_DELETE_FAIL,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_UPDATE_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
} from "./constants/user";

export const getUserList = (page: number, limit: number) => async (dispatch: any) => {
  try {
    dispatch({ type: USER_LIST_REQUEST });

    const { data } = await api.get("/users", {
      params: {
        page,
        limit
      }
    });

    dispatch({
      type: USER_LIST_SUCCESS, payload: data
    });
  } catch (err: any) {
    dispatch({
      type: USER_LIST_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const deleteUser = (id: string | undefined) => async (dispatch: any) => {
  try {
    dispatch({ type: USER_DELETE_REQUEST });

    await api.delete(`/users/${id}`);

    dispatch({ type: USER_DELETE_SUCCESS });
  } catch (err: any) {
    dispatch({
      type: USER_DELETE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const updateUser = (user: any) => async (dispatch: any) => {
  try {
    dispatch({ type: USER_UPDATE_REQUEST });

    const { data } = await api.put(`/users/${user._id}`, user);

    dispatch({ type: USER_UPDATE_SUCCESS, payload: data });
  } catch (err: any) {
    dispatch({
      type: USER_UPDATE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
